// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertToFormData = (data: Record<string, any>) => {
  const formData = new FormData()

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        formData.append(key, '')
      } else {
        value.forEach(item => {
          formData.append(key, item)
        })
      }
    } else {
      formData.append(
        key,
        value === null || value === undefined ? '' : String(value)
      )
    }
  })

  return formData
}

export const convertBytestoMBs = (bytes: number) => {
  const megabytes = bytes / (1024 * 1024)

  return megabytes.toFixed(2) ? megabytes.toFixed(2) + ' MB' : '' // Output: "0.64 MB"
}

export const formatTimeAgo = (timestamp: string | Date) => {
  try {
    const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
    const now = new Date()
    const secondsAgo = Math.floor((now.getTime() - date.getTime()) / 1000)

    // Less than a minute
    if (secondsAgo < 60) {
      return 'just now'
    }

    // Minutes
    const minutesAgo = Math.floor(secondsAgo / 60)
    if (minutesAgo < 60) {
      return minutesAgo === 1 ? 'a minute ago' : `${minutesAgo} minutes ago`
    }

    // Hours
    const hoursAgo = Math.floor(minutesAgo / 60)
    if (hoursAgo < 24) {
      return hoursAgo === 1 ? 'an hour ago' : `${hoursAgo} hours ago`
    }

    // Days
    const daysAgo = Math.floor(hoursAgo / 24)
    if (daysAgo < 7) {
      return daysAgo === 1 ? 'a day ago' : `${daysAgo} days ago`
    }

    // Weeks
    const weeksAgo = Math.floor(daysAgo / 7)
    if (weeksAgo < 4) {
      return weeksAgo === 1 ? 'a week ago' : `${weeksAgo} weeks ago`
    }

    // Months
    const monthsAgo = Math.floor(daysAgo / 30)
    if (monthsAgo < 12) {
      return monthsAgo === 1 ? 'a month ago' : `${monthsAgo} months ago`
    }

    // Years
    const yearsAgo = Math.floor(monthsAgo / 12)
    return yearsAgo === 1 ? 'a year ago' : `${yearsAgo} years ago`
  } catch (error) {
    console.error('Error formatting time ago:', error)
    return 'some time ago'
  }
}

export const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes < 1024) return `${sizeInBytes} bytes`
  const units = ['KB', 'MB', 'GB', 'TB']
  let size = sizeInBytes / 1024
  let unitIndex = 0

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024
    unitIndex++
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`
}
